import { search } from './searchService';
import { getById, post } from './apiService';
import type { Agent } from '../types/agent';
import type { SearchParams } from '../types/search';

export interface AgentFilter {
  clientId?: string;
}

export async function getAgentById(id: string): Promise<Agent> {
  return getById<Agent>('/agent', id);
}

export async function createAgent(data: {
  clientId: string;
  propertyId: string;
  name: string;
}): Promise<Agent> {
  return post<Agent>('/agent', data);
}

export async function searchAgents(
  filter: AgentFilter = {},
  params: SearchParams = {},
): Promise<Agent[]> {
  return search<Agent>('/agent/search', filter, params);
}
